import * as React from "react";
import { useLayoutEffect, useRef, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { InputDescription } from "components/common";
import { FormGroup, ControlLabel } from "components/bootstrap";
import useInputListStyles from "./useInputListStyles";
import { GenericChangeEvent } from "./InputList.types";
const createOption = (value) => ({
  label: value,
  value
});
const InputList = ({
  name,
  values,
  onChange,
  label = null,
  size = "normal",
  bsStyle = null,
  error = null,
  help = null,
  ...rest
}) => {
  const { inputListTheme, styles } = useInputListStyles(size);
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [value, setValue] = useState(values.map((val) => createOption(val)));
  useLayoutEffect(() => {
    setValue(values.map((val) => createOption(val)));
  }, [values]);
  const dispatchOnChange = (newValue) => {
    const newList = newValue.map((item) => item.value);
    const event = new GenericChangeEvent("change");
    inputRef.current.value = newList;
    inputRef.current.name = name;
    event.target = inputRef.current;
    onChange(event);
  };
  const handleKeyDown = (event) => {
    if (!inputValue) return;
    if (event.key === "Enter" || event.key === "Tab") {
      const newValue = [...value, createOption(inputValue)];
      setValue(newValue);
      dispatchOnChange(newValue);
      setInputValue("");
      event.preventDefault();
    }
  };
  const handleOnChange = (newValue) => {
    setValue(newValue);
    dispatchOnChange(newValue);
  };
  return /* @__PURE__ */ React.createElement(FormGroup, { controlId: rest.id ? rest.id : name, validationState: error ? "error" : bsStyle }, label && /* @__PURE__ */ React.createElement(ControlLabel, null, label), /* @__PURE__ */ React.createElement(
    CreatableSelect,
    {
      ref: inputRef,
      components: { DropdownIndicator: null },
      inputValue,
      isMulti: true,
      menuIsOpen: false,
      onChange: handleOnChange,
      onInputChange: (newValue) => setInputValue(newValue),
      onKeyDown: handleKeyDown,
      value,
      styles: styles(!error),
      theme: (theme) => ({ ...theme, ...inputListTheme }),
      ...rest
    }
  ), /* @__PURE__ */ React.createElement(InputDescription, { error, help }));
};
export default InputList;
